import { AddCportalUserRequest, CportalServiceItem, SendCportalEmailRequest } from 'vopay';
import { useEffect, useState } from 'react';
import axios from 'axios';
import vopayApi from '@/services/api.config';
const { api } = vopayApi;

export default function useCportal() {
  const source = axios.CancelToken.source();

  const [services, setServices] = useState<CportalServiceItem[]>([]);
  const [cPortalLink, setCPortalLink] = useState('');

  useEffect(() => {
    return () => {
      source.cancel();
    };
  }, []);

  const addCportalUser = async (request: AddCportalUserRequest) => {
    try {
      const res = await api.addCportalUser(request, source);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const fetchAccountCportalSettings = async () => {
    try {
      const res = await api.fetchAccountCportalSettings(source);
      if (!res.Success) throw new Error(res.ErrorMessage);
      if (res?.Services) {
        setServices(res.Services);
      }
      if (res?.cPortalLink) {
        setCPortalLink(res.cPortalLink);
      }

      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  const sendCportalEmail = async (request: SendCportalEmailRequest) => {
    try {
      const res = await api.sendCportalEmail(request, source);
      if (!res.Success) throw new Error(res.ErrorMessage);

      return res;
    } catch (err) {
      console.error(err);
      throw err;
    }
  };

  return {
    services,
    cPortalLink,
    addCportalUser,
    fetchAccountCportalSettings,
    sendCportalEmail,
  };
}
